// Material 3 Checkbox (18px rounded box, 40px state layer). Wraps MUI Checkbox (same props) + optional label.
(function () {
  const { Checkbox: MuiCheckbox, FormControlLabel } = MaterialUI;

  const box = (extra) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    borderRadius: 2,
    boxSizing: 'border-box',
    transition: 'all var(--m3-duration-short) var(--m3-easing-standard)',
    ...extra
  });

  const Mark = ({ path }) => (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" style={{ fill: 'var(--m3-on-primary)' }}>
      <path d={path} />
    </svg>
  );

  const unchecked = <span style={box({ border: '2px solid var(--m3-on-surface-variant)' })} />;
  const checked = <span style={box({ background: 'var(--m3-primary)' })}><Mark path="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" /></span>;
  const indeterminate = <span style={box({ background: 'var(--m3-primary)' })}><Mark path="M5 11h14v2H5z" /></span>;

  function Checkbox({ label, sx = {}, ...props }) {
    const control = (
      <MuiCheckbox
        icon={unchecked}
        checkedIcon={checked}
        indeterminateIcon={indeterminate}
        disableRipple
        sx={{
          p: '11px',
          borderRadius: '50%',
          '&:hover': { backgroundColor: 'color-mix(in srgb, var(--m3-on-surface) 8%, transparent)' },
          '&.Mui-checked:hover, &.MuiCheckbox-indeterminate:hover': {
            backgroundColor: 'color-mix(in srgb, var(--m3-primary) 8%, transparent)'
          },
          '&.Mui-focusVisible': { outline: '3px solid var(--m3-secondary)', outlineOffset: -3 },
          '&.Mui-disabled': { opacity: 0.38 },
          ...sx
        }}
        {...props}
      />
    );
    return label ? <FormControlLabel control={control} label={label} /> : control;
  }

  window.Components = window.Components || {};
  window.Components.Checkbox = Checkbox;
})();
